/* eslint-disable no-nested-ternary */
import clsx from "clsx"
import { motion } from "framer-motion"
import Link from "next/link"
import type { Ref } from "react"
import React, { useContext } from "react"

import LinkOut from "../../../../../public/icons/link-out.svg"
import PageThemeContext from "../../page-theme/PageThemeContext"
import type { TSubMenu } from "../types/navigation"

const Submenu: React.FC<TSubMenu> = React.forwardRef(
  ({ heading, links }, ref: Ref<HTMLDivElement>) => {
    const pageThemeContext = useContext(PageThemeContext)
    const headingColorClass = pageThemeContext.pageTheme.dark
      ? "text-gray-2.5 group-hover:text-gray-40"
      : "text-gray-90 group-hover:text-gray-60"
    const subHeadingColorClass = pageThemeContext.pageTheme.dark
      ? "text-gray-40"
      : "text-gray-60"
    return (
      <div
        ref={ref}
        className="mb-12 md:mb-0 md:col-span-2 lg:col-span-6 md:px-8"
      >
        {heading && (
          <h2
            className={clsx(
              "mb-0 caption1 md:mb-8 lg:mb-10",
              subHeadingColorClass,
            )}
          >
            {heading}
          </h2>
        )}
        <ul>
          {links.map(
            ({ linkTo, heading: headingLink, subheading, outbound }) => (
              <li key={headingLink}>
                <Link
                  href={linkTo}
                  className={clsx(
                    "block group header-link",
                    subheading
                      ? "md:mb-8 lg:mb-6 xl:mb-8"
                      : heading
                        ? "mb-4"
                        : "md:mb-8 lg:mb-6 xl:mb-8",
                  )}
                  target={outbound ? "_blank" : ""}
                >
                  <div className={clsx("heading2", headingColorClass)}>
                    {headingLink}
                    {outbound && (
                      <LinkOut
                        alt="Link Out Icon"
                        className="ml-2 mb-1 inline stroke-blue-50"
                      />
                    )}
                  </div>
                  {subheading && (
                    <div
                      className={clsx(
                        "hidden md:body3 md:block",
                        subHeadingColorClass,
                      )}
                    >
                      {subheading}
                    </div>
                  )}
                </Link>
              </li>
            ),
          )}
        </ul>
      </div>
    )
  },
)

export default motion(Submenu, { forwardMotionProps: true })
